import React, { useState } from 'react';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import AlertCircleWarning from 'src/assets/images/AlertCircleWarning.svg';
import {
    Text,
    DesktopWrap,
    UnsavedChangesDiv,
} from 'src/pages/scheduleSurgery/components/surgery/notifications/Notifications.styled';
import { sizes } from 'src/styles/Media.styled';
import { isIpad } from 'src/utils/util';
import { useSelector } from 'react-redux';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const CancelAlertPopup = ({
    popupTitle,
    alertMessage,
    btn1Label,
    btn2Label,
    btn1ClickHandler,
    btn2ClickHandler,
    isProcedureBtnClicked,
    isReplishBtnClicked,
    isInUnidSurgeryInfoPage,
    btnCloseClickHandler,
    isSurgeryNonUsePopup,
    cancelBtn,
    isUnidInfo,
    isDelayPositionChange,
    fromPriceOverride,
    isBundleBulkAdd,
    isFromPop,
}) => {
    const iPad = isIpad();
    const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffectWithErrorLogging(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <Popup
                title={popupTitle}
                onClose={
                    btnCloseClickHandler
                        ? btnCloseClickHandler
                        : btn2ClickHandler
                }
                img={
                    fromPriceOverride ? AlertCircleWarning : AlertCircleOutline
                }
                // popHeight={
                //     isLanguageChanged &&
                //     windowWidth <= sizes.mobileDevice &&
                //     btn1Label
                //         ? '38%'
                //         : btn2Label && '40%'
                // }
                // minHeight={'40%'}
                isFromPop={(btn2Label || btn1Label) && true}
                height={'30px'}
                paddingTop={'0px'}
                isDelayPositionChange={isDelayPositionChange}
                fromMore={isBundleBulkAdd}
                id={'reportUsage-cancelAlertPopup-popup'}
            >
                <UnsavedChangesDiv
                    divHeight={
                        windowWidth <= sizes.mobileDevice &&
                        (isProcedureBtnClicked ||
                            isSurgeryNonUsePopup ||
                            isReplishBtnClicked ||
                            ((popupTitle === 'Locked For Editing' || popupTitle === '編集中のためロックされています') && btn2Label))
                            ? '205px !important'
                            : '140px'
                    }
                >
                    <Text
                        flexGrow={'0.5'}
                        height={'auto'}
                        font={`${
                            isProcedureBtnClicked ? '15px' : '14px'
                        } Avenir Next World`}
                        lineHeight={'20px'}
                        textPadding={'12px 12px'}
                    >
                        {alertMessage}
                    </Text>
                    <DesktopWrap
                        flexDirection={
                            isUnidInfo
                                ? iPad
                                    ? 'column'
                                    : 'row'
                                : windowWidth <= sizes.mobileDevice
                                ? 'column-reverse'
                                : 'row'
                        }
                        alignItems={
                            isUnidInfo
                                ? iPad && 'center'
                                : windowWidth <= sizes.mobileDevice &&
                                  'center'
                        }
                        justifyContent={!btn2Label && 'center'}
                    >
                        <Button
                            id={'reportUsage-common-cancelAlertPopup-btn1'}
                            show
                            width={'290px'}
                            height={'38px'}
                            // primary={isInUnidSurgeryInfoPage}
                            // secondary={isSurgeryNonUsePopup}
                            // discard={!cancelBtn}
                            // cancel={cancelBtn}
                            variant={isInUnidSurgeryInfoPage ? ButtonStyles?.primary : isSurgeryNonUsePopup ? ButtonStyles?.secondary : cancelBtn ? ButtonStyles?.cancel : ButtonStyles?.discard}
                            // borderRadius={'19px'}
                            margin={
                                btn2Label
                                    ? isUnidInfo
                                        ? iPad
                                            ? '0 0 6px 0'
                                            : windowWidth <= sizes.mobileDevice
                                            ? '0 0 10px 0'
                                            : '0 10px 0 0'
                                        : windowWidth <= sizes.mobileDevice
                                        ? '10px 0 0 0'
                                        : '0 10px 0 0'
                                    : undefined
                            }
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={btn1ClickHandler}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {btn1Label}
                            </div>
                        </Button>
                        {btn2Label && (
                            <Button
                                id={'reportUsage-common-cancelAlertPopup-btn2'}
                                // primary
                                variant={ButtonStyles?.primary}
                                show
                                width={'290px'}
                                height={'38px'}
                                // borderRadius={'19px'}
                                // fontSize={'15px'}
                                // fontFamily={'AvenirNextWorld Demi'}
                                clicked={btn2ClickHandler}
                            >
                                <div style={{ whiteSpace: 'nowrap' }}>
                                    {btn2Label}
                                </div>
                            </Button>
                        )}
                    </DesktopWrap>
                </UnsavedChangesDiv>
            </Popup>
        </>
    );
};

export default CancelAlertPopup;
